import { Route, Switch } from 'react-router'

import { ProfileRoutes } from 'enum/routes'
import CreateProfile from './pages/CreateProfile'
import LMSProfile  from './pages/Main'
import EditProfile from './pages/EditProfile'

export const LmsProfilesPage = () => {
  return (
    <Switch>
      <Route path={ProfileRoutes.CREATE}>
        <CreateProfile />
      </Route>
      <Route path={ProfileRoutes.EDIT}>
        <EditProfile />
      </Route>
      <Route path={ProfileRoutes.MAIN}>
        <LMSProfile />
      </Route>
    </Switch>
  )
}
